export default "__VITE_ASSET__87d4ba54__"